import { Alert, Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { AGE_ARRAY } from '../../../consts/ages';

export const ChangeChild = ({
    idChild,
    nameStart,
    ageStart,
    handlerName,
    handlerAge,
    handleChange,
    error }) => {

    return (
        <div>
            <form className='user-child-change_form'
                autoComplete='off'
                onSubmit={(element) => handleChange(idChild, element)}>
                <TextField id='standard-basic'
                    label="Ім'я"
                    variant='standard'
                    value={nameStart}
                    onChange={e => handlerName(e.target.value)} />
                <FormControl variant='standard' sx={{
                    margin: '0 16px',
                    width: '50%',
                    '@media (max-width: 650px)': { margin: '16px 0', width: '100%' }
                }}>
                    <InputLabel id='demo-simple-select-standard-label'>
                        Вік дитини
                    </InputLabel>
                    <Select
                        labelId='demo-simple-select-error-label'
                        id='demo-simple-select-standard'
                        value={ageStart}
                        label='Виберіть вік дитини'
                        onChange={e => handlerAge(e.target.value)}
                        renderValue={(value) => `${value}`}>
                        {AGE_ARRAY.map((text, index) =>
                            <MenuItem value={text} key={index}>
                                {text}
                            </MenuItem>)}
                    </Select>
                </FormControl>
                <Button variant='outlined'
                    type='submit'
                    sx={{
                        borderColor: '#6565f5',
                        color: '#6565f5',
                        '&:hover': { borderColor: '#4d4de9' }
                    }}>
                    Змінити
                </Button>
            </form>
            {error &&
                <Alert severity='error' sx={{ marginTop: '6px' }}>
                    Поля не можуть бути пустими
                </Alert>
            }
        </div>
    )
}